import { render, staticRenderFns } from "./fechas.vue?vue&type=template&id=1cab7bb8"
import script from "./fechas.vue?vue&type=script&lang=js"
export * from "./fechas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports